export default __webpack_public_path__ + "static/media/dentistry.b13b1446.svg";